/**
 * The white card the monitoring Settings tab is built out of (DOP-480).
 *
 * It was `MetricsCard` inside `MetricsView`; two files now draw the same card,
 * so it gets a file of its own rather than a second copy of the padding.
 */

import React from "react";

export interface MonitoringSettingsCardProps {
	title: string;
	children: React.ReactNode;
}

const MonitoringSettingsCard: React.FC<MonitoringSettingsCardProps> = ({
	title,
	children,
}) => (
	<section className="rounded-xl border border-gray-200 bg-white p-5">
		<h3 className="text-[15px] font-semibold text-[#111111]">{title}</h3>
		<div className="mt-2">{children}</div>
	</section>
);

export default MonitoringSettingsCard;
